import getFixedGatsbyImage from './getFixedGatsbyImage'
import getFluidGatsbyImage from './getFluidGatsbyImage'

export { getFixedGatsbyImage, getFluidGatsbyImage }
